import React, { Component } from 'react';
import ModalAvailability from './ModalAvailability';
import ModalInactive from './ModalInactive';
import ModalInvoiceList from './ModalInvoiceList';
import ModalDocuments from './ModalDocuments';
import ModalInspiration from './ModalInspiration';
import Gravatar from 'react-gravatar';
import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import InputMask from 'react-input-mask';


class BookingQuickview extends Component {
    constructor(props){
        super(props);
        this.state = {
          editTime:false,
          startTime:new Date(this.props.quickviewBooking.utc_date),
          edit:false,
          quickviewBooking:null
        }
    }

    componentDidMount(){
      this.setState({
        quickviewBooking:this.props.quickviewBooking
      })
    }

    componentWillReceiveProps(nextProps){
      this.setState({
        editTime:false,
        startTime:new Date(nextProps.quickviewBooking.utc_date),
        quickviewBooking:nextProps.quickviewBooking
      })
    }

    handleInputChange = (e) => {
        let updated_obj = Object.assign({}, this.state.quickviewBooking);
        updated_obj[e.target.name] = e.target.value;
        this.setState({quickviewBooking:updated_obj});
    }

    handleChange = (date) => {
      this.setState({
        startTime: date
      });
    }

  render() {
    const {edit, quickviewBooking} = this.state;
    const {modalHandler, servicesHandler, closeHandler, scheduleHandler, startTimeHandler, resetHandler, resendHandler, editHandler} = this.props;
    if (!quickviewBooking) return <React.Fragment>No Booking</React.Fragment>;
    return (
        <PerfectScrollbar>
        <div className="quickview-body">
          <div className="card card-inverse mb-0">
            <div className="px-20 pt-20">
              <a className="pull-right text-white fs-20 lh-1 cursor-pointer" onClick={closeHandler}><i className="fa fa-close"></i></a>
            </div>

            <div className="card-body text-center pb-10">
              <Gravatar email={quickviewBooking.email} size={96} rating="pg" default="identicon" className="avatar avatar-xxl avatar-bordered" />
              <h4 className="mt-2 mb-0 text-white">{quickviewBooking.first_name} {quickviewBooking.last_name}</h4>
              <span><i className="fa fa-envelope w-20px"></i> <a className="hover-primary text-white" href={"mailto:" + quickviewBooking.email}>{quickviewBooking.email}</a></span><br/>
              <span><i className="fa fa-phone w-20px"></i> {quickviewBooking.phone}</span>
            </div>
          </div>
          <div className="quickview-block pb-0">
            {edit ?
              <form className="card form-type-combine">
                <div className="form-groups-attached">
                    <div className="row">
                        <div className="form-group col-12">
                            <label>Booking Name</label>
                            <input type="text" className="form-control" name="event_name" value={quickviewBooking.event_name} onChange={this.handleInputChange} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-6">
                            <label>First Name</label>
                            <input type="text" className="form-control" name="first_name" value={quickviewBooking.first_name} onChange={this.handleInputChange} />
                        </div>
                        <div className="form-group col-6">
                            <label>Last Name</label>
                            <input type="text" className="form-control" name="last_name" value={quickviewBooking.last_name} onChange={this.handleInputChange} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-8">
                            <label>Email</label>
                            <input type="email" className="form-control" name="email" value={quickviewBooking.email} onChange={this.handleInputChange} />
                        </div>
                        <div className="form-group col-4">
                            <label>Phone</label>
                            <InputMask className="form-control" mask="(999)-999-9999" maskChar=" " name="phone" value={quickviewBooking.phone} onChange={this.handleInputChange} />
                        </div>
                    </div>
                    <div className="form-group">
                        <label>Location Name</label>
                        <input className="form-control" type="text" name="location_name" value={quickviewBooking.location_name} onChange={this.handleInputChange}/>
                    </div>
                    <div className="row">
                        <div className="form-group col-12">
                            <label>Address</label>
                            <input className="form-control" type="text" name="address" value={quickviewBooking.address} onChange={this.handleInputChange}/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-6">
                            <label>City</label>
                            <input className="form-control" type="text" name="city" value={quickviewBooking.city} onChange={this.handleInputChange}/>
                        </div>
                        <div className="form-group col-2">
                            <label>State</label>
                            <input className="form-control" type="text" name="state" value={quickviewBooking.state} onChange={this.handleInputChange}/>
                        </div>
                        <div className="form-group col-4">
                            <label>Postal Code</label>
                            <input className="form-control" type="text" name="postal_code" value={quickviewBooking.postal_code} onChange={this.handleInputChange}/>
                        </div>
                    </div>
                    <div className="form-group">
                      <div className="btn-group">
                        <button className="btn btn-secondary" type="button" onClick={()=>this.setState({edit:false})}>Cancel</button>
                        <button className="btn btn-primary" type="button" onClick={()=>editHandler(quickviewBooking)}>Save</button>
                      </div>
                    </div>
                </div>
              </form>
              :
              <dl className="row">
              {!this.state.editTime ?
                <React.Fragment>
                  <dt className="col-sm-3">Ready Time</dt>
                  <dd className="col-sm-9"><React.Fragment>{quickviewBooking.date} @ {quickviewBooking.ready_time} <a onClick={()=>{this.setState({editTime:!this.state.editTime})}}><i className="fa fa-pencil text-info cursor-pointer"></i></a></React.Fragment></dd>
                </React.Fragment>
                :
                <React.Fragment>
                  <dd className="col-sm-12">
                    <DatePicker
                      selected={this.state.startTime}
                      onChange={this.handleChange}
                      showTimeSelect
                      timeIntervals={5}
                      inline
                      dateFormat="h:mm aa"
                      timeCaption="Time"
                    />
                    <a className="ml-10" onClick={()=>{startTimeHandler(this.state.startTime)}}><i className="fa fa-check text-success cursor-pointer"></i></a>
                    <a className="ml-10" onClick={()=>{this.setState({editTime:!this.state.editTime})}}><i className="fa fa-close text-danger cursor-pointer"></i></a>
                </dd>
                </React.Fragment>
                }
                <dt className="col-sm-3">Location</dt>
                <dd className="col-sm-9" style={{lineHeight:18+'px'}}>
                <address>
                  <strong>{quickviewBooking.location_name} <a target="_blank" href={'http://maps.google.com/?q='+quickviewBooking.address + quickviewBooking.address2}><i className="fa fa-external-link text-info"></i></a></strong><br/>
                  {quickviewBooking.address}<br/>
                  {quickviewBooking.address2}
                </address>
                </dd>
                {quickviewBooking.location_instructions && quickviewBooking.location_instructions !== '' ?
                <React.Fragment>
                <dt className="col-sm-3">Instructions</dt>
                <dd className="col-sm-9" style={{lineHeight:18+'px'}}>{quickviewBooking.location_instructions}</dd>
                </React.Fragment>
                : null}
                <dt className="col-sm-3">Modified</dt>
                <dd className="col-sm-9">{quickviewBooking.last_modified}<br/><strong>{quickviewBooking.age_of}</strong></dd>
              </dl>
            }
          </div>
        </div>
        <footer className="p-12 text-center">
          <div className="btn-group btn-block btn-group-vertical">
              <button className="btn btn-lg btn-outline btn-block btn-secondary" onClick={(event) => servicesHandler(quickviewBooking)}><i className="fa-fw fa fa-scissors"></i> Services</button>
              <button className="btn btn-lg btn-outline btn-block btn-secondary" onClick={(event) => modalHandler(quickviewBooking, ModalAvailability, "Assign Artists for " + quickviewBooking.date + " @ " + quickviewBooking.ready_time)}><i className="fa-fw fa fa-users"></i> Assign Artists</button>
              <button className="btn btn-lg btn-outline btn-block btn-secondary" onClick={(event) => modalHandler(quickviewBooking, ModalInspiration, "Inspiration Ideas")}><i className="fa-fw fa fa-lightbulb-o"></i> Inspiration Ideas</button>
              <button className="btn btn-lg btn-outline btn-block btn-secondary" onClick={(event) => scheduleHandler(quickviewBooking)}><i className="fa-fw fa fa-clock-o"></i> Set Schedule</button>
              <button className="btn btn-lg btn-outline btn-block btn-secondary" onClick={(event) => modalHandler(quickviewBooking, ModalDocuments, "Event Documents")}><i className="fa-fw fa fa-file-pdf-o"></i> Event Documents</button>
              <button className="btn btn-lg btn-outline btn-block btn-secondary" onClick={(event) => modalHandler(quickviewBooking, ModalInvoiceList, "Payments & Invoices for " + quickviewBooking.full_name + " Event" )}><i className="fa-fw fa fa-money"></i> Payments & Invoices</button>
              <div className="btn-group">
                <button class="btn btn-lg btn-outline btn-block btn-secondary dropdown-toggle" data-toggle="dropdown" aria-expanded="false">Additional Actions</button>
                <div class="dropdown-menu" x-placement="bottom-start" style={{position:"absolute", willChange: "top, left", top: 36+"px", left: 0+"px"}}>
                  <a className="dropdown-item" href={"mailto:" + quickviewBooking.email}><i className="fa fa-fw fa-envelope"></i> Message</a>
                  <a class="dropdown-item" href="#" onClick={resendHandler}><i className="fa-fw fa fa-asterisk"></i> Send Account Information</a>
                  <a class="dropdown-item" href="#" onClick={resetHandler}><i className="fa-fw fa fa-refresh"></i> Reset Password</a>
                  <a class="dropdown-item" href="#" onClick={()=>this.setState({edit:true})}><i className="fa-fw fa fa-pencil"></i> Update Event</a>
                </div>
              </div>
              <button className="btn btn-lg btn-outline btn-block btn-danger" onClick={(event) => modalHandler(quickviewBooking, ModalInactive, "Inactivate Booking")}><i className="fa fa-fw fa-trash"></i> Mark Inactive</button>
              <button className="btn btn-lg btn-outline btn-block btn-info" onClick={closeHandler}><i className="fa fa-fw fa-close"></i> Close</button>
          </div>
        </footer>
        </PerfectScrollbar>
    )
  }
}

export default BookingQuickview;



// WEBPACK FOOTER //
// ./src/components/business/BookingQuickview.js